/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DistributionChannel } from './DistributionChannel';
import {
    DistributionChannelFromJSON,
    DistributionChannelFromJSONTyped,
    DistributionChannelToJSON,
    DistributionChannelToJSONTyped,
} from './DistributionChannel';
import type { DistributionStyle } from './DistributionStyle';
import {
    DistributionStyleFromJSON,
    DistributionStyleFromJSONTyped,
    DistributionStyleToJSON,
    DistributionStyleToJSONTyped,
} from './DistributionStyle';
import type { DomainStatus } from './DomainStatus';
import {
    DomainStatusFromJSON,
    DomainStatusFromJSONTyped,
    DomainStatusToJSON,
    DomainStatusToJSONTyped,
} from './DomainStatus';

/**
 * One way a surface is served, and the style it renders in there.
 * @export
 * @interface Distribution
 */
export interface Distribution {
    /**
     * 
     * @type {DistributionChannel}
     * @memberof Distribution
     */
    channel: DistributionChannel;
    /**
     * 
     * @type {DistributionStyle}
     * @memberof Distribution
     */
    style: DistributionStyle;
    /**
     * Hostname, for CUSTOM_DOMAIN only. Authoritative ownership lives on the CustomDomain collection.
     * @type {string}
     * @memberof Distribution
     */
    domain?: string;
    /**
     * 
     * @type {DomainStatus}
     * @memberof Distribution
     */
    domainStatus?: DomainStatus;
    /**
     * Whether this channel is actually live. Defaults true. False stages a channel — a layout picked, a hostname typed — without turning it on, e.g. a CUSTOM_DOMAIN configured ahead of DNS verification, or a HUB layout being previewed before it goes public.
     * @type {boolean}
     * @memberof Distribution
     */
    enabled?: boolean;
}



/**
 * Check if a given object implements the Distribution interface.
 */
export function instanceOfDistribution(value: object): value is Distribution {
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('style' in value) || value['style'] === undefined) return false;
    return true;
}

export function DistributionFromJSON(json: any): Distribution {
    return DistributionFromJSONTyped(json, false);
}

export function DistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Distribution {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': DistributionChannelFromJSON(json['channel']),
        'style': DistributionStyleFromJSON(json['style']),
        'domain': json['domain'] == null ? undefined : json['domain'],
        'domainStatus': json['domainStatus'] == null ? undefined : DomainStatusFromJSON(json['domainStatus']),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function DistributionToJSON(json: any): Distribution {
    return DistributionToJSONTyped(json, false);
}

export function DistributionToJSONTyped(value?: Distribution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channel': DistributionChannelToJSON(value['channel']),
        'style': DistributionStyleToJSON(value['style']),
        'domain': value['domain'],
        'domainStatus': DomainStatusToJSON(value['domainStatus']),
        'enabled': value['enabled'],
    };
}

